import { urlStoredFilter } from '../../../scripts/utils/urlStoredFilter';
import { sendCustomEvent } from '../../../scripts/config/analytics';

const URL_SORTED_FILTER_SELECTOR = 'data-url-stored-filter-menu';

export function runIndexHeroInit() {
  const tabsTitlesList = getTabsFiltersArray();
  const filterEmmiter = urlStoredFilter({
    initValue: tabsTitlesList[0],
    dataKey: 'tab',
    listeners: [handleChangeTab],
  });

  let activeTabValue =
    document
      .querySelector(`[${URL_SORTED_FILTER_SELECTOR}][data-active="true"]`)
      ?.getAttribute('data-tab') || tabsTitlesList[0];

  let isAutoPlay = false;
  let isArrowClick = false;

  function handleChangeTab(newTabValue) {
    activeTabValue = newTabValue;

    if (!isAutoPlay) {
      sendCustomEvent({
        category: 'Hero Carousel',
        action: 'Button Click',
        label: isArrowClick ? 'arrow' : newTabValue,
      });
      stopSliderAutoplay();
    }
  }

  const slideDelay = 4000;
  const nextArrowIndex = 1;
  let timerId = 1;
  const tabsWrapper = document.querySelector('[data-index-hero-filters]');

  const runSliderAutoplay = () => {
    tabsWrapper.setAttribute('data-index-hero-filters-autoplay', 'true');

    setTimeout(function changeSlide() {
      isAutoPlay = true;
      const newValue = getLeftAndRightTabMask()[activeTabValue][nextArrowIndex];

      filterEmmiter.emit(newValue);
      // NOTE: To call stopSliderAutoplay and sendEvent only on click
      isAutoPlay = false;

      timerId = setTimeout(changeSlide, slideDelay);
    }, slideDelay);
  };

  function stopSliderAutoplay() {
    clearInterval(timerId);
    tabsWrapper.setAttribute('data-index-hero-filters-autoplay', 'false');
  }

  const arrowItems = document.querySelectorAll('[data-index-hero-arrow]');

  arrowItems.forEach((arrowEl) => {
    arrowEl.addEventListener('click', () => {
      const arrowMaskIndex = arrowEl.getAttribute('data-index-hero-arrow');
      const newValue = getLeftAndRightTabMask()[activeTabValue][arrowMaskIndex];

      isArrowClick = true;
      filterEmmiter.emit(newValue);
      // NOTE: If the next click is triggered by a tab
      isArrowClick = false;
    });
  });

  function getTabsFiltersArray() {
    const tabs = [
      ...document.querySelectorAll(`[${URL_SORTED_FILTER_SELECTOR}]`),
    ];

    return tabs.map((tab) => tab.getAttribute('data-tab')).filter(Boolean);
  }

  /* Note: expected value
   * {
   *   filterName1: ["app", "control"],
   *   filterName2: ["system", "switch"],
   *   ...
   * }
   */
  function getLeftAndRightTabMask() {
    return tabsTitlesList.reduce((acc, tab, i) => {
      const tabsCount = tabsTitlesList.length - 1;
      const nextTabValue = tabsTitlesList[i + 1];
      const prevTabValue = tabsTitlesList[i - 1];
      const firstTabValue = tabsTitlesList[0];
      const lastTabValue = tabsTitlesList[tabsCount];

      if (i === 0) {
        acc[tab] = [lastTabValue, nextTabValue];
      } else if (i === tabsCount) {
        acc[tab] = [prevTabValue, firstTabValue];
      } else {
        acc[tab] = [prevTabValue, nextTabValue];
      }

      return acc;
    }, {});
  }

  return { runSliderAutoplay };
}
